export const BOOKSY = 'https://therealturkishbarber.booksy.com/a';
export const WHATSAPP_BRAY = 'https://wa.me/353899440644';
export const whatsappUrl = (text) =>
  text ? `${WHATSAPP_BRAY}?text=${encodeURIComponent(text)}` : WHATSAPP_BRAY;
export const CALL_TEL = 'tel:+353899440644';
export const PHONE_DISPLAY = '089 944 0644';
export const LOGO =
  'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/x9jbgojv_Lodo%20Pc.png';

export const ADDRESS = 'Belton House, 2 Castle St, Bray Commons, Bray, Co. Wicklow, A98 E8P8';
export const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS)}`;
export const GOOGLE_REVIEWS_URL =
  'https://www.google.com/maps/search/?api=1&query=The+Real+Turkish+Barber+Bray';

export const INSTAGRAM = 'https://www.instagram.com/therealturkishbarber';
export const TIKTOK = 'https://www.tiktok.com/@therealturkishbarber';
export const FACEBOOK = 'https://www.facebook.com/therealturkishbarber';

export const navLinks = [
  { key: 'home', id: 'home' },
  { key: 'services', id: 'services' },
  { key: 'prices', id: 'prices' },
  { key: 'gallery', id: 'gallery' },
  { key: 'reviews', id: 'reviews' },
  { key: 'findUs', id: 'find-us' }
];

export const scrollToId = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
